import { render, staticRenderFns } from "./twoEnIndex.vue?vue&type=template&id=04c1352d&scoped=true"
import script from "./twoEnIndex.vue?vue&type=script&lang=js"
export * from "./twoEnIndex.vue?vue&type=script&lang=js"
import style0 from "./twoEnIndex.vue?vue&type=style&index=0&id=04c1352d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1352d",
  null
  
)

export default component.exports